import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b6061ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "data ws_mr5" }
const _hoisted_2 = { class: "ws_drawer_footer" }

import { ref, watch, computed } from 'vue'
import type { FormInstance } from 'element-plus'
import { ElMessage } from 'element-plus'
import i18n from '@/i18n'
import {
  CODE_ENUM,
  REPORT_DATA_TYPE,
  REPORT_EXECUTE_METHOD_TYPE,
  REPORT_TIME_TYPE,
  REPORT_EXECUTE_FREQUENCY_TYPE,
} from '@/common'
import { useDeviceStore } from '@/stores/device'
import {
  queryReportConfigAttr,
  addReportConfig,
  queryReportConfigDetail,
  updateReportConfig,
} from '@/api'
import moment from 'moment'
import { isEmpty } from 'lodash'


export default /*#__PURE__*/_defineComponent({
  __name: 'report-config-form-drawer',
  props: ['visible', 'data'],
  emits: ['update:visible', 'success'],
  setup(__props, { emit: $emit }) {

const props = __props;

const deviceStore = useDeviceStore()

deviceStore.queryDeviceOps()

const t = i18n.global.t



watch(
  () => props.visible,
  () => {
    if (props.visible && props.data?.id) {
      queryDetail()
    }
  }
)

const dataType = [
  {
    label: t('STATISTICS.rfdataType1'),
    value: REPORT_DATA_TYPE.ORIGIN,
  },

  {
    label: t('STATISTICS.rfdataType2'),
    value: REPORT_DATA_TYPE.AGGREGATION,
  },
]

const stepMap = {
  H: {
    label: t('STATISTICS.h'),
    value: 'H',
  },
  D: {
    label: t('STATISTICS.d'),
    value: 'D',
  },
  M: {
    label: t('STATISTICS.month'),
    value: 'M',
  },
  Y: {
    label: t('STATISTICS.y'),
    value: 'Y',
  },
}

const timeMap = {
  [REPORT_TIME_TYPE.LAST_ONE_DAY]: ['H'],
  [REPORT_TIME_TYPE.LAST_ONE_WEEK]: ['H', 'D'],
  [REPORT_TIME_TYPE.LAST_ONE_MONTH]: ['H', 'D'],
  [REPORT_TIME_TYPE.LAST_THREE_MONTH]: ['H', 'D'],
  [REPORT_TIME_TYPE.LAST_ONE_YEAR]: ['H', 'D', 'M'],
}

// fuck
const step: any = ref([])
const onLatestTimeChange = (value: any, noReset?: any) => {
  // 如果等于自定义 等选了时间再去做判断
  if (value === REPORT_TIME_TYPE.CUSTOM) {
    return
  }
  if (!noReset) {
    formData.value.statisticsTime = ''
  }
  step.value = timeMap[value].map((key: string) => {
    return stepMap[key]
  })
}

const onCustomTimeChange = (value: any) => {
  if (!value) {
    step.value = []
  } else {
    const [start, end] = value
    const ONE_DAY = 1000 * 60 * 60 * 24
    const timeS = moment(end).valueOf() - moment(start).valueOf()
    let key = ''

    // 小于一天
    if (timeS < ONE_DAY) {
      key = REPORT_TIME_TYPE.LAST_ONE_DAY
    } else if (timeS > ONE_DAY * 31 * 3) {
      // 大于三个月
      key = REPORT_TIME_TYPE.LAST_ONE_YEAR
    } else {
      key = REPORT_TIME_TYPE.LAST_THREE_MONTH
    }
    formData.value.statisticsTime = ''
    step.value = timeMap[key].map((k: string) => {
      return stepMap[k]
    })
  }
}

const condition = [
  {
    label: t('STATISTICS.condition1'),
    value: 'MAX-MIN',
  },
  {
    label: t('STATISTICS.condition2'),
    value: 'MAX',
  },
  {
    label: t('STATISTICS.condition3'),
    value: 'MIN',
  },
  {
    label: t('STATISTICS.condition4'),
    value: 'AVG',
  },
  {
    label: t('STATISTICS.condition5'),
    value: 'SUM',
  },
  {
    label: t('STATISTICS.condition6'),
    value: 'COUNT',
  },
  {
    label: t('STATISTICS.condition7'),
    value: 'DIF',
  },
]

const timeOps = [
  {
    label: t('STATISTICS.rftimeOps1'),
    value: REPORT_TIME_TYPE.LAST_ONE_DAY,
  },
  {
    label: t('STATISTICS.rftimeOps6'),
    value: REPORT_TIME_TYPE.LAST_ONE_WEEK,
  },
  {
    label: t('STATISTICS.rftimeOps2'),
    value: REPORT_TIME_TYPE.LAST_ONE_MONTH,
  },
  {
    label: t('STATISTICS.rftimeOps3'),
    value: REPORT_TIME_TYPE.LAST_THREE_MONTH,
  },
  {
    label: t('STATISTICS.rftimeOps4'),
    value: REPORT_TIME_TYPE.LAST_ONE_YEAR,
  },
  {
    label: t('STATISTICS.rftimeOps5'),
    value: REPORT_TIME_TYPE.CUSTOM,
  },
]

const weekMap = {
  1: t('STATISTICS.rfweek1'),
  2: t('STATISTICS.rfweek2'),
  3: t('STATISTICS.rfweek3'),
  4: t('STATISTICS.rfweek4'),
  5: t('STATISTICS.rfweek5'),
  6: t('STATISTICS.rfweek6'),
  7: t('STATISTICS.rfweek7'),
}

const frequencyOps = [
  {
    label: t('STATISTICS.rffrequencyOps1'),
    value: REPORT_EXECUTE_FREQUENCY_TYPE.DAY,
  },
  {
    label: t('STATISTICS.rffrequencyOps2'),
    value: REPORT_EXECUTE_FREQUENCY_TYPE.WEEK,
  },
  {
    label: t('STATISTICS.rffrequencyOps3'),
    value: REPORT_EXECUTE_FREQUENCY_TYPE.MONTH,
  },
]
const formData: any = ref({
  reportName: '',
  dataType: '',
  statisticsType: '',
  limit: undefined,
  statisticsTime: '',
  executeMethod: REPORT_EXECUTE_METHOD_TYPE.IMMEDIATELY,
  latestTime: '',
  customTime: [],
  executeDevice: '',
  frequency: '',
  codeSet: '',
  codeSetList: [],
  selectedDayOfWeek: '',
  selectedDayOfMonth: '',
  dailyTime: '',
  reportDesc: '',
})

const cancel = async () => {
  $emit('update:visible', false)
  formRef.value.resetFields()
  formData.value = {
    reportName: '',
    dataType: '',
    statisticsType: '',
    limit: undefined,
    statisticsTime: '',
    executeMethod: REPORT_EXECUTE_METHOD_TYPE.IMMEDIATELY,
    latestTime: '',
    customTime: [],
    executeDevice: '',
    frequency: '',
    codeSet: '',
    codeSetList: [],
    selectedDayOfWeek: '',
    selectedDayOfMonth: '',
    dailyTime: '',
    reportDesc: '',
  }
  step.value = []
}

const rules: any = {
  reportName: [{ required: true, message: t('STATISTICS.rfenter') }],
  dataType: [{ required: true, message: t('STATISTICS.rfselect') }],
  statisticsType: [{ required: true, message: t('STATISTICS.rfselect') }],
  limit: [{ required: true, message: t('STATISTICS.rfenter') }],
  executeMethod: [{ required: true, message: t('STATISTICS.rfselect') }],
  latestTime: [{ required: true, message: t('STATISTICS.rfselect') }],
  statisticsTime: [{ required: true, message: t('STATISTICS.rfselect') }],
  frequency: [{ required: true, message: t('STATISTICS.rfselect') }],
  customTime: [{ required: true, message: t('STATISTICS.rfselect') }],
  selectedDayOfWeek: [{ required: true, message: t('STATISTICS.rfselect') }],
  selectedDayOfMonth: [{ required: true, message: t('STATISTICS.rfselect') }],
  dailyTime: [{ required: true, message: t('STATISTICS.rfselect') }],
  executeDevice: [{ required: true, message: t('STATISTICS.rfselect') }],
  codeSetList: [{ required: true, message: t('STATISTICS.rfselect') }],
  codeSet: [{ required: true, message: t('STATISTICS.rfselect') }],
}

const loading = ref(false)
const formRef: any = ref<FormInstance>()
const handleSubmit = () => {
  formRef.value.validate(async (valid: boolean) => {
    if (valid) {
      loading.value = true
      const fn = props.data?.id ? updateReportConfig : addReportConfig
      const res: any = await fn(dealWithData()).finally(() => {
        loading.value = false
      })
      loading.value = false
      if (res?.code === CODE_ENUM.SUCCESS) {
        ElMessage({
          message: res?.msg,
          type: 'success',
        })
        cancel()
        $emit('success')
      }
    }
  })
}

// 处理多余数据
const dealWithData = () => {
  const {
    reportName,
    dataType,
    statisticsType,
    limit,
    statisticsTime,
    executeMethod,
    latestTime,
    customTime,
    executeDevice,
    frequency,
    codeSet,
    codeSetList,
    selectedDayOfWeek,
    selectedDayOfMonth,
    dailyTime,
  } = formData.value

  return {
    reportName,
    dataType,
    statisticsType,
    limit,
    statisticsTime,
    executeMethod,
    latestTime,
    customTime,
    executeDevice,
    frequency,
    selectedDayOfWeek,
    selectedDayOfMonth,
    executeAttributeList:
      dataType === REPORT_DATA_TYPE.ORIGIN ? codeSetList : [codeSet],
    dailyTime: dailyTime ? moment(dailyTime).format('HH:mm') : '',
    startTime: isEmpty(customTime) ? '' : moment(customTime[0]).valueOf(),
    endTime: isEmpty(customTime) ? '' : moment(customTime[1]).valueOf(),
    id: props.data?.id,
  }
}

const queryDetail = async () => {
  const res: any = await queryReportConfigDetail({
    id: props.data.id,
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    const {
      reportName,
      dataType,
      statisticsType,
      limit,
      statisticsTime,
      executeMethod,
      latestTime,
      executeDevice,
      frequency,
      selectedDayOfWeek,
      selectedDayOfMonth,
      dailyTime,
      executeAttributeList,
      startTime,
      endTime,
    } = res.data

    await onDeviceChange(executeDevice, true)
    onLatestTimeChange(latestTime, true)
    let customTime: any = []
    if (latestTime === REPORT_TIME_TYPE.CUSTOM) {
      customTime = [moment(startTime).valueOf(), moment(endTime).valueOf()]
      onCustomTimeChange(customTime)
    }

    let moDailyTime: any = ''
    if (dailyTime) {
      const str = moment().format('YYYY-MM-DD')
      moDailyTime = moment(str + ' ' + dailyTime).valueOf()
    }

    formData.value = {
      ...formData.value,
      reportName,
      dataType,
      statisticsType,
      limit,
      statisticsTime,
      executeMethod,
      latestTime,
      customTime,
      executeDevice,
      frequency,
      codeSet:
        dataType === REPORT_DATA_TYPE.ORIGIN
          ? ''
          : isEmpty(executeAttributeList)
          ? ''
          : executeAttributeList[0],
      codeSetList:
        dataType === REPORT_DATA_TYPE.ORIGIN ? executeAttributeList : [],
      selectedDayOfWeek,
      selectedDayOfMonth,
      dailyTime: moDailyTime,
    }
  }
}
const codeSet = ref([])
const onDeviceChange = async (deviceId: string, noReset?: any) => {
  const res: any = await queryReportConfigAttr({
    deviceId,
  })
  if (!noReset) {
    formData.value.codeSetList = []
    formData.value.codeSet = ''
  }

  if (res?.code === CODE_ENUM.SUCCESS) {
    codeSet.value = res.data
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_time_picker = _resolveComponent("el-time-picker")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    "model-value": props.visible,
    title: 
      props.data.id ? _ctx.$t('STATISTICS.rffTitleEdit') : _ctx.$t('STATISTICS.rffTitle')
    ,
    size: "510px",
    "before-close": cancel
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_2, [
        _createVNode(_component_el_button, {
          loading: loading.value,
          type: "primary",
          onClick: handleSubmit
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('STATISTICS.rfYes')), 1)
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_el_button, { onClick: cancel }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('STATISTICS.rfNo')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_form, {
          model: formData.value,
          rules: rules,
          ref_key: "formRef",
          ref: formRef,
          "label-position": "left",
          "label-width": "80"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              prop: "reportName",
              label: _ctx.$t('STATISTICS.rfName')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.reportName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.reportName) = $event)),
                  maxlength: "20",
                  placeholder: _ctx.$t('STATISTICS.rfNamePla')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              prop: "dataType",
              label: _ctx.$t('STATISTICS.rfDateType')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  class: "ws_select_form",
                  modelValue: formData.value.dataType,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.dataType) = $event)),
                  placeholder: _ctx.$t('STATISTICS.rfDateTypePla')
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(dataType, (item) => {
                      return _createVNode(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            (formData.value.dataType === _unref(REPORT_DATA_TYPE).AGGREGATION)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  prop: "statisticsType",
                  label: _ctx.$t('STATISTICS.rfStatisticsType')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      class: "ws_select_form",
                      modelValue: formData.value.statisticsType,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.statisticsType) = $event)),
                      placeholder: _ctx.$t('STATISTICS.rfStatisticsTypePla')
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(condition, (item) => {
                          return _createVNode(_component_el_option, {
                            key: item.value,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"])
                        }), 64))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            (formData.value.dataType === _unref(REPORT_DATA_TYPE).ORIGIN)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  prop: "limit",
                  label: _ctx.$t('STATISTICS.rflimit')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      class: "ws_common_input_number",
                      modelValue: formData.value.limit,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.limit) = $event)),
                      maxlength: "20",
                      placeholder: _ctx.$t('STATISTICS.rflimitPla'),
                      controls: false,
                      max: 10000,
                      min: 1
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, {
              prop: "latestTime",
              label: _ctx.$t('STATISTICS.rflatestTime')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  class: "ws_select_form",
                  modelValue: formData.value.latestTime,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.latestTime) = $event)),
                  placeholder: _ctx.$t('STATISTICS.rflatestTimePla'),
                  onChange: onLatestTimeChange
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(timeOps, (item) => {
                      return _createVNode(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            (formData.value.latestTime === _unref(REPORT_TIME_TYPE).CUSTOM)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 2,
                  prop: "customTime",
                  label: "",
                  "label-width": 80
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: formData.value.customTime,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.customTime) = $event)),
                      "unlink-panels": "",
                      type: "datetimerange",
                      "range-separator": "-",
                      "start-placeholder": _ctx.$t('STATISTICS.startTime'),
                      "end-placeholder": _ctx.$t('STATISTICS.endTime'),
                      editable: false,
                      onChange: onCustomTimeChange
                    }, null, 8, ["modelValue", "start-placeholder", "end-placeholder"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, {
              prop: "statisticsTime",
              label: _ctx.$t('STATISTICS.rfstatisticsTime')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  class: "ws_select_form",
                  modelValue: formData.value.statisticsTime,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.statisticsTime) = $event)),
                  placeholder: _ctx.$t('STATISTICS.rfstatisticsTimePla')
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(step.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              prop: "executeMethod",
              label: _ctx.$t('STATISTICS.rfexecuteMethod')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: formData.value.executeMethod,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.executeMethod) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, {
                      label: _unref(REPORT_EXECUTE_METHOD_TYPE).IMMEDIATELY,
                      size: "large"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('STATISTICS.rfexecuteMethod1')), 1)
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_radio, {
                      label: _unref(REPORT_EXECUTE_METHOD_TYPE).CYCLE,
                      size: "large"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('STATISTICS.rfexecuteMethod2')), 1)
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            (formData.value.executeMethod === _unref(REPORT_EXECUTE_METHOD_TYPE).CYCLE)
              ? (_openBlock(), _createBlock(_component_el_row, {
                  key: 3,
                  class: "time-box"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      class: "select",
                      prop: "frequency",
                      label: "",
                      "label-width": 1
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: formData.value.frequency,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.frequency) = $event)),
                          placeholder: _ctx.$t('STATISTICS.rffrequency')
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(frequencyOps, (item) => {
                              return _createVNode(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"])
                            }), 64))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    }),
                    (formData.value.frequency === _unref(REPORT_EXECUTE_FREQUENCY_TYPE).WEEK)
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 0,
                          class: "select",
                          prop: "selectedDayOfWeek",
                          label: "",
                          "label-width": 1
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: formData.value.selectedDayOfWeek,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.selectedDayOfWeek) = $event)),
                              placeholder: _ctx.$t('STATISTICS.rffrequencyPla')
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(7, (item) => {
                                  return _createVNode(_component_el_option, {
                                    key: item,
                                    label: weekMap[item],
                                    value: item
                                  }, null, 8, ["label", "value"])
                                }), 64))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "placeholder"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (formData.value.frequency === _unref(REPORT_EXECUTE_FREQUENCY_TYPE).MONTH)
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 1,
                          class: "select",
                          prop: "selectedDayOfMonth",
                          label: "",
                          "label-width": 1
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: formData.value.selectedDayOfMonth,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.value.selectedDayOfMonth) = $event)),
                              placeholder: _ctx.$t('STATISTICS.rfselectedDayOfMonth')
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(31, (item) => {
                                  return _createVNode(_component_el_option, {
                                    key: item,
                                    label: item,
                                    value: item
                                  }, null, 8, ["label", "value"])
                                }), 64))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "placeholder"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_form_item, {
                      class: "time",
                      prop: "dailyTime",
                      label: "",
                      "label-width": 1
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_time_picker, {
                          modelValue: formData.value.dailyTime,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.value.dailyTime) = $event)),
                          format: "HH:mm",
                          placeholder: _ctx.$t('STATISTICS.rfdailyTimePla')
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_row, { gutter: 10 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 15 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      prop: "executeDevice",
                      label: _ctx.$t('STATISTICS.rfexecuteDevice')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          class: "ws_select_form",
                          modelValue: formData.value.executeDevice,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.value.executeDevice) = $event)),
                          placeholder: _ctx.$t('STATISTICS.rfexecuteDevicePla'),
                          onChange: onDeviceChange
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(deviceStore).deviceOps, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 9 }, {
                  default: _withCtx(() => [
                    (formData.value.dataType === _unref(REPORT_DATA_TYPE).ORIGIN)
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 0,
                          prop: "codeSetList",
                          label: "",
                          "label-width": 0.01
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              class: "ws_select_form",
                              modelValue: formData.value.codeSetList,
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formData.value.codeSetList) = $event)),
                              placeholder: _ctx.$t('STATISTICS.rfcodeSetListPla'),
                              multiple: ""
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(codeSet.value, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.code,
                                    label: item.name,
                                    value: item.code
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "placeholder"])
                          ]),
                          _: 1
                        }, 8, ["label-width"]))
                      : (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 1,
                          prop: "codeSet",
                          label: "",
                          "label-width": 0.01
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              class: "ws_select_form",
                              modelValue: formData.value.codeSet,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formData.value.codeSet) = $event)),
                              placeholder: _ctx.$t('STATISTICS.rfcodeSetListPla')
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(codeSet.value, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.code,
                                    label: item.name,
                                    value: item.code
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "placeholder"])
                          ]),
                          _: 1
                        }, 8, ["label-width"]))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              prop: "reportDesc",
              label: _ctx.$t('STATISTICS.rfdesc')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.reportDesc,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((formData.value.reportDesc) = $event)),
                  maxlength: "50",
                  placeholder: _ctx.$t('STATISTICS.rfdescPla'),
                  rows: 3,
                  type: "textarea"
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ]),
    _: 1
  }, 8, ["model-value", "title"]))
}
}

})